import React, { JSX } from 'react';
import { colors, css, fonts} from '../../Styles';
import { progressColor } from '../../Definitions';
import { styled } from 'styletron-react';
import { TooltipString } from '../';

interface ProgressCircle_Props {
  total?: number
  progressed?: number
  header?: string
  unit?: JSX.Element
  animation?: boolean
  noDataDisclaimer?: string
  tooMuchFedDisclaimer?: boolean
  focusView?: boolean
}
/**
 * ProgressCircle
 * @param total The total value representing 100% progress.
 * @param progressed The current progress value towards the total.
 * @param header The optional title displayed above the progress circle.
 * @param unit An optional JSX element displayed below the progress circle.
 * @param animation Enables a smooth animation when the progress value updates.
 * @returns A circular progress circle with an optional header and unit display.
 */
export default function ProgressCircle ({total = 0, progressed = 0, header, animation = false, unit, noDataDisclaimer, tooMuchFedDisclaimer, focusView = false}:ProgressCircle_Props) {
  
  // if (progressed === 0 && total === 0) {
  //   return <div>{noDataDisclaimer?noDataDisclaimer: "No Data"}</div>;
  // }

  const tooMuchFed = progressed < 0

    const progressedPercentage = total > 0 && !tooMuchFed 
  ? (progressed / total) * 100 
  : 0;

  const strokeDasharray = `${progressedPercentage}, 100`;

  const progressAnimation = {
    "0%": { strokeDasharray: "0, 100" },
    "100%": { strokeDasharray: `${progressedPercentage}, 100`}
  };

  // #region | Circle SVG and style
  const BackgroundPath = styled("path", {
    stroke: colors.greyTertiary,
    fill: "none",
    strokeWidth: "3.6px"
  });

  const AnimatedPath = styled("path", {
    stroke: progressColor(progressedPercentage),
    fill: "none",
    strokeWidth: "4px",
    strokeLinecap: "round",
    strokeDasharray: strokeDasharray,
    animationName: animation ? progressAnimation : "unset",
    animationDuration: "2s",
    animationTimingFunction: "ease",
    animationFillMode: "forwards"
  });

  const circle = (
    <svg viewBox="0 0 36 36" style={{
        display: "block",
      maxHeight: "120px",
        maxWidth: "120px",
    }}>
      <BackgroundPath d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/> 
      <AnimatedPath d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
    </svg>
  )
  // #endregion

  const negative = (
    <TooltipString overrides={{contentstring: {color: colors.systemRed, ...(focusView ? fonts.fontSize4 : fonts.fontSize5)}}} contentString={<div style={{border: "1px solid "+colors.systemRed, borderRadius: "10px", width: "40px", height: focusView ? "17px" : "15px", boxSizing: "border-box", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: "0"}}>{`+${Math.abs(progressed)}`}</div>} tooltipString={`Kg fed more than expected`} />
  )

  return ( 
    <div style={{position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "end", gap: "10px", height: focusView ? "222px" : "170px", }}>
      <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary, textAlign: "center", maxWidth: focusView ? "120px" : undefined}}>{header}</p>
      <div style={{position: "relative", width: "120px", height: "120px"}}>
        {circle}
        <div style={{ 
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          ...fonts.header,
        }}>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
            <p style={{ ...(focusView ? fonts.fontSize0 : fonts.fontSize1), color: progressColor(progressedPercentage), margin: "0px" }}>{`${!tooMuchFed ? progressed : 0}`}</p>
            <p style={{ ...(focusView ? fonts.fontSize3 : fonts.fontSize4), color: colors.greyPrimary, margin: "0px" }}>{`/ ${total}`}</p>
          </div>
        </div>
      </div>
      <div style={{height: "15px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%"}}>{unit}</div>
      {tooMuchFed && tooMuchFedDisclaimer
        ? <div style={{ position: focusView ? "relative" : "absolute", transform: focusView ? undefined : "translateX(-50%)", left: focusView ? undefined : "50%", top: focusView ? undefined : "175px" }}>{negative}</div>
          : focusView && !tooMuchFed ? <div style={{ height: "17px" }}/>
        : <></>}
    </div> 
  );
};